import { render } from "./BasicSkeleton.vue?vue&type=template&id=1fa37f72&scoped=true"
const script = {}

import "./BasicSkeleton.vue?vue&type=style&index=0&id=1fa37f72&scoped=true&lang=css"

import exportComponent from "../../../../login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa37f72"]])

export default __exports__